import React, { Component } from 'react';
import styled from 'styled-components';
import Flex, { FlexItem } from 'styled-flex-component';
import { GlobalStyle } from './style/base';

import logo from './thibodeau_floors_logo.svg';
import hero_kitchen from './images/hero_kitchen-min.png';
import profile from './images/tracy_profile.png';

const Heading = styled.h1`
  font-size: 18px;
  margin: 0 0 12px 0;

  @media (min-width: 768px) {
    font-size: 24px;
	}
`;

const AppContainer = styled(Flex)`
  background-color: #F0F0F0;
  margin: 0 auto;
`;

const Header = styled(Flex)`
  background-color: hsb(0,0,0);
  padding: 24px 12px;
`;

const Logo = styled.img`
  width: auto;
  height: 20px;

  @media (max-width: 320px) {
    height: 18px;
	}

  @media (min-width: 768px) {
    height: 40px;
	}
`;

const Button = styled.a`
  border-radius: 3px;
  color: #fff;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,.15);
  padding: 12px;
  text-decoration: none;
  background: #6FB126;

  @media (max-width: 320px) {
    font-size: .75rem;
    padding: 8px;
	}
`;

const Hero = styled(Flex)`
  background-image: url(${hero_kitchen});
  background-color: hsb(0,0,30);
  background-size: cover;
  min-height: 300px;

  @media (min-width: 768px) {
    min-height: 480px;
    box-shadow: 0 3px 3px 0 rgba(0,0,0,.05);
	}
  
`;

const Content = styled(Flex)`
  flex-direction: column;
  margin: 24px 0;

  @media (max-width: 320px) {
   margin-bottom: 60px;
	}

  @media (min-width: 768px) {
    flex-direction: row;
	}
`;

const Benefit = styled(FlexItem)`
  width: 100vw;
  padding: 0 12px;

  @media (min-width: 768px) {
    max-width: 24vw;
	}
`;

const Footer = styled(Flex)`
  background: #fff;
  box-shadow: 0 3px 3px 0 rgba(0,0,0,.05);
  padding: 24px 0;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const About = styled(Flex)`
  flex-direction: column;

  @media (min-width: 768px) {
    max-width: 48vw;
    padding: 0 24px;
  }
`;
const Social = styled(FlexItem)`
  @media (max-width: 767px) {
    align-self: center;
    img {
      margin-top: -74px;
      width: 120px;
    }
  }
  @media (min-width: 768px) {
    img {
      max-width: 140px;
    }
	}
`;
const Bio = styled(FlexItem)`
  margin-bottom: 24px;
  padding: 0 12px;
`;

const CompanyInfo = styled(Flex)`
  flex-direction: column;

  @media (min-width: 768px) {
    max-width: 48vw;
	}

  @media (min-width: 1024px) {
    flex-direction: row;
	}
`;

const Services = styled(FlexItem)`
  padding: 0 12px;
  margin-bottom: 24px;

  @media (min-width: 1024px) {
    width: 25vw;
	}
`;

class App extends Component {
  render() {
    return (
      <AppContainer column>
        <Header alignCenter justifyBetween>
          <FlexItem>
          <Logo src={logo} alt="thibodeau floors custom hardwood floors logo" />
          </FlexItem>
          <FlexItem>
            <Button href="tel:+1-916-769-7894">+1 916-769-7894</Button>
          </FlexItem>
        </Header>
        <Hero>
        </Hero>
        <Content>
          <Benefit>
            <p>There are many benefits to hardwood floors but a few of the most common among customers are...</p>
          </Benefit>
          <Benefit>
            <Heading>Value</Heading>
            <p>Although real hardwood has a higher cost up front, a quality hardwood floor can outlast the life of a home.</p>
          </Benefit>
          <Benefit>
            <Heading>Sustainability</Heading>
            <p>Hardwood floors are timeless and can be refinished and stained multiple times to look like new.</p>
          </Benefit>
          <Benefit>
            <Heading>Cleanliness</Heading>
            <p>They are hypoallergenic. Unlike carpet, wood floors don’t stain and won’t capture dust mites, pet dander or other allergens.</p>
          </Benefit>
        </Content>
        <Footer>
          <About>
            <Social>
              <img src={profile} alt="Tracy Thibodeau hand scraping custom hardwood floors"/>
            </Social>
            <Bio>
              <Heading>Hi, I’m Tracy.</Heading>
              <p>
                I’ve been working with hardwood floors since 1991. I founded Thibodeau Floors in 2001 to serve Sacramento and surrounding areas.
                I’ve since moved farther north to Placer County and typically serve this region.
              </p>
              <p>
                I specialize in unfinished hardwood flooring. I prefer their sustainability, longevity and durability.
              </p>
            </Bio>
          </About>
          <CompanyInfo>
            <Services column>
              <Heading>Flooring Services</Heading>
              <ul>
                <li>Unfinished hardwood flooring</li>
                <li>Sanding / Refinishing / Repairs</li>
                <li>Hand scraping / Wire brushing</li>
                <li>Custom patterns / Parquet / Herringbone</li>
                <li>Inlays / Borders / Coloring</li>
              </ul>
              <p>
                Don’t see something you want? Chances are I can do it.
              </p>
            </Services>
            <Services column>
              <Heading>Service Areas</Heading>
              <p>Granite Bay, Roseville, Rocklin, Lincoln, Penryn, Loomis, Newcastle, Auburn, Meadow vista and Colfax.</p>

              <p>I mostly serve Placer County, but I’m open to working anywhere for unique projects.</p>
            </Services>
          </CompanyInfo>
        </Footer>
        <GlobalStyle/>
      </AppContainer>
    );
  }
}

export default App;
